import { toastError } from '@onestep/coreui/Toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import useMixpanel from '../../../../hooks/useMixpanel';
import useStores from '../../../../hooks/useStores';
import useAdministrationService from '../administration';
import type { ITypeOfCare } from './types';

export default function useTypeOfCareService() {
  const { trackFail } = useMixpanel();
  const {
    patientsServiceStore: { queryKey },
  } = useStores();
  const administration = useAdministrationService();
  const queryClient = useQueryClient();

  const createTypeOfCareAction = useMutation({
    mutationFn: async (typeOfCare: Partial<ITypeOfCare>) => {
      try {
        if (!typeOfCare.typeUuid) return;
        await axios.post(`/api/camel/type_of_care/`, typeOfCare);

        administration.refetch();
        invalidatePatientsQueries();
      } catch (error) {
        toastError({ content: 'Failed to create type of care!' });
        trackFail('create_type_of_care', { error });
      }
    },
  });

  const invalidatePatientsQueries = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return {
    createTypeOfCare: createTypeOfCareAction.mutateAsync,
  };
}
